import TranslationSettings from '../store/schema/TranslationSettings';
import { isFeatureEnabled } from 'owa-feature-flags';
import {
    getOptionsForFeature,
    lazyCreateOrUpdateOptionsForFeature,
    OwsOptionsFeatureType,
    TranslationOptions,
} from 'owa-outlook-service-options';

// We are saving translation settings to Outlook Options stoarge here.
// We are moving the setting from Outlook options to OCS. For the first run we copy
// the setting from OO to OCS and for the subsequent runs we copy the settings from
// OCS to OO. To identify if this is the first run, we add the value of 0x10 to the
// mode value. When we read the value, if this value is within range, it is first run,
// otherwise it is not.
export default async function storeOutlookOptions(settings: TranslationSettings) {
    const options = getOptionsForFeature<TranslationOptions>(OwsOptionsFeatureType.Translation);
    options.translationMode = isFeatureEnabled('tra-useOcsSettings')
        ? settings.translationMode + 0x10
        : settings.translationMode;
    options.targetLanguage = settings.targetLanguage;
    options.excludedLanguages = settings.excludedLanguages;

    await lazyCreateOrUpdateOptionsForFeature.importAndExecute(
        OwsOptionsFeatureType.Translation,
        options
    );
}
